import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicTagboOzor from "../Components/ProjPicTagboOzor";

const ProjectPageTagboOzor = () => {
    return (
        <>
            <Navbar />
            <ProjPicTagboOzor />
            <Footer />
        </>
    );
};

export default ProjectPageTagboOzor;
